import * as React from "react";
import Content from "../../../../../react-core/Datepicker/Resources/ContentContent";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { WizardComponent } from "../../../../Shared/Process/WizardComponent";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { ConvertToFlexiAction } from "./Actions/ConvertToFlexiActions";
import { Review } from "./Components/Review";
import { SelectArrangement } from "./Components/SelectArrangement";
import { convertToFlexiStepperName } from "./Resource/Content";
import { ConvertToFlexiInstructionStore } from "./Store/Variable";

export class ConvertCappedToFlexiWizard extends WizardComponent {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(ConvertToFlexiInstructionStore, () => this.onInstructionStoreChange());
    }

    private onInstructionStoreChange() {
        if (ConvertToFlexiInstructionStore.getActionType() == ActionType.Success) {
            const data = ConvertToFlexiInstructionStore.getData();
            this.setState({
                isLoading: false,
                data: data,
            });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const hierarchyId = getQueryParameters()["hierarchyid"];
        const instructionId = getQueryParameters()["id"];
        ConvertToFlexiAction.getInstruction(hierarchyId, instructionId);
    }

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {
        if (from == stepLength - 1) {return this.onExit();}
        if (!params["id"]) {params["id"] = this.state.data.InstructionId;}

        ConvertToFlexiAction.saveInstruction(this.state.data, (result) => {
            this.setState({ onPosting: false });
            if (result.length > 0) {
                this.setState({ errorMsg: result, isShowErrorMsg: true });
            } else {
                if (to == -1) {
                    this.onExit();
                } else {
                    Navigator.navigateTo(toUrl, {
                        queryParamsObject: params,
                        scrollAfterNavigating: true,
                    });
                }
            }
        });
    }

    onCancel() {
        this.onExit();
    }

    onExit() {
        const params = getQueryParameters();
        //TODO: navigate to customer dashboard
        // Navigator.navigateTo(Urls.get().main.ClientDashboard, {
        //     queryParamsObject: {
        //         hierarchyid: params["hierarchyid"],
        //     },
        //     scrollAfterNavigating: true,
        // });
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        ConvertToFlexiAction.submitInstruction(this.state.data, (result) => {
            this.setState({ isSubmitting: false });
            if (!result.SubmissionSucceed) {
                this.setState({
                    active: true,
                    errorMsg: [`There was an error when processing`],
                });
            }
        });
    }

    setStepperConfig() {
        const clAccountId = getQueryParameters()["claccountid"];
        const { data } = this.state;

        this.stepperConfig = [
            {
                title: convertToFlexiStepperName.selectArrangement,
                url: Urls.get().ConvertToFlexiSelectArrangement,
                path: Contents.URLMap.selectArrangement,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <SelectArrangement {...this.getStepProps(0)}></SelectArrangement>,
            },
            {
                title: convertToFlexiStepperName.review,
                url: Urls.get().ConvertToFlexiReview,
                path: Contents.URLMap.review,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[this.stepperConfig.length - 2].isValid(),
                component: (
                    <Review
                        {...this.getStepProps(1)}
                        onClearError={() => this.setState({ errorMsg: [], isShowErrorMsg: false })}
                    ></Review>
                ),
            },
            {
                title: convertToFlexiStepperName.confirmation,
                url: Urls.get().ConvertToFlexiConfirmation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: (
                    <Confirmation
                        onExit={() => {
                            this.state.errorMsg.length > 0
                                ? Navigator.navigateToAndPreserveQueryParameters(Urls.get().ConvertToFlexiReview)
                                : this.onExit();
                        }}
                        buttonLabel={this.state.errorMsg.length > 0 ? "Previous" : "Back to dashboard"}
                        errorMsg={this.state.errorMsg[0]}
                        successMessage={`We've received your instruction for ${data?.ClientDetail?.FirstName}  ${data?.ClientDetail?.LastName} (${clAccountId})
                        .`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "Convert capped to flexi";
        processProps.onSave = null;
        processProps.goBacktoFirst = true;
        return processProps;
    }
}
